import { combineReducers } from "redux";

import { reducer as taxSlipsPreferenceReducer } from "modules/preferences/taxSlips/reducer";

import { PreferencesState } from "./models";

export const reducer = combineReducers<PreferencesState>({
    taxSlipsPreference: taxSlipsPreferenceReducer
});
